import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Sanitize a value for CSV (escape quotes, wrap if needed)
const csvCell = (v) => {
  if (v == null) return '';
  const s = String(v);
  if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const exportToCSV = (rows, columns, filename) => {
  const header = columns.map(c => csvCell(c.label)).join(';');
  const lines = rows.map(r => columns.map(c => csvCell(c.value(r))).join(';'));
  // BOM ensures Excel reads UTF-8 properly
  const csv = '\uFEFF' + [header, ...lines].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  triggerDownload(blob, `${filename}.csv`);
};

export const exportToXLSX = (rows, columns, filename, sheetName = 'Export') => {
  const aoa = [
    columns.map(c => c.label),
    ...rows.map(r => columns.map(c => c.value(r))),
  ];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = columns.map(c => ({ wch: c.width || 18 }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

export const exportToPDF = (rows, columns, filename, title) => {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  if (title) {
    doc.setFontSize(14);
    doc.text(title, 40, 40);
  }
  autoTable(doc, {
    startY: title ? 60 : 40,
    head: [columns.map(c => c.label)],
    body: rows.map(r => columns.map(c => {
      const v = c.value(r);
      return v == null ? '' : String(v);
    })),
    styles: { fontSize: 9, cellPadding: 4 },
    headStyles: { fillColor: [13, 124, 95], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    margin: { left: 40, right: 40 },
  });
  doc.save(`${filename}.pdf`);
};
